
var partials_pull  = [];    
function loading_partial(){
    if($.isEmptyObject(partials_pull)){
        $('body').removeClass('partials-loading');
    }else if(!$.isEmptyObject(partials_pull) ){
        $('body').addClass('partials-loading')
    }
}

    
function append_partial( container , cb){

    if(container.length == 0){
        return false;
    }

    var unique_partial_id = Math.floor(Math.random()* 1000000),
        d = container.data(),
        data = {};

    for(var i in d){
        if(i!='partial'){
            data[i] = d[i];
        }
    }
    

    $('body').addClass('loading');
    //container.css('opacity',0.2);
    container.css('pointer-events','none');
    container.css('min-height',container.height());
    container.addClass('loading');
    container.append('<div class="spinner-wrapper parial-loader"><div class="spinner-border"></div></div>');

    if (container.attr('id') == "products-list-filter") {
        container.append(products_loading_template);
    }
    if (container.attr('data-partial') == "products.aggregates") {
        container.append(products_filter_loading_template);
    }



    if(data){
        data.current_url = window.location.pathname;
    }
    if(container.data('xhr')){
        container.data('xhr').abort();
    }

    var ext_domain = '';
    if (container.data('ext_domain')) {
        ext_domain = container.data('ext_domain');
    }

   $.ajax({
        url     : ext_domain + '/partial/' + d.partial,
        data    : data,
        method  : 'GET',

        success: function (data) {

            var newContent;
            if(data.markup){
                  newContent = $(data.markup).html();
            }else{
                  newContent = $(data).html();
            }
           
            var t = container.append(newContent);
            
           container.css('pointer-events','auto');
            

            container.removeClass('loading');
            $('body').removeClass('loading');
            container.find('.parial-loader').remove();

            container.animate({'opacity':1},500);
            container.css('pointer-events','auto');
            container.css('min-height','auto');


            container.css('min-height','0');

            if(typeof(cb) !== 'undefined'){
                cb(newContent);
            }

            loading_partial();
        },
        error: function (response) {
            loading_partial();
        }
    });

    loading_partial();
    
}
function load_partial( container , cb){

    if(container.length == 0){
        return false;
    }

    var unique_partial_id = Math.floor(Math.random()* 1000000),
        d = container.data(),
        data = {};

    for(var i in d){
        if(i!='partial'){
            data[i] = d[i];
        }
    }
    
   
    $('body').addClass('loading');
   // container.css('opacity',0.2);
    container.css('pointer-events','none');
    container.css('min-height',container.height());
    container.addClass('loading');
    container.append('<div class="spinner-wrapper parial-loader"><div class="spinner-border"></div></div>');

    if (container.attr('id') == "products-list-filter") {
        container.append(products_loading_template);
    }
    if (container.attr('data-partial') == "products.aggregates") {
        container.append(products_filter_loading_template);
    }



    if(data){
        data.current_url = window.location.pathname;
    }
    if(container.data('xhr')){
        container.data('xhr').abort();
    }

    var ext_domain = '';
    if (container.data('ext_domain')) {
        ext_domain = container.data('ext_domain');
    }
    
   $.ajax({
        url     : ext_domain + '/partial/' + d.partial,
        data    : data,
        method  : 'GET',

        success: function (data) {
            var newContent = $(data.markup);
            var t = container.replaceWith(newContent);
            
           container.css('pointer-events','auto');
            if(newContent.text().length == 0){
                container.hide();
            }else{
                container.show();
            } 

            container.removeClass('loading');
            $('body').removeClass('loading');
            container.find('.parial-loader').remove();
            $('#' + newContent.attr('id')).removeClass('loading');

            container.css('min-height','0');

            if(typeof(cb) !== 'undefined'){
                cb(newContent);
            }

            loading_partial();

            
            initForm(container);
           
            Waypoint.destroyAll();
            $('.way-point-animate').waypoint(function() { 
                $(this.element).addClass('shown');
            }, {
                offset: '98%'
            });     

              


        },
        error: function (response) {
            loading_partial();
        }
    });
   
    loading_partial();
    
}

function openPartialModal($theTriggerer, data, cb, cb2) {
    $('body').addClass('partials-loading');
    $('body').append('<span class="loader partial-loader"></span>');
    if ($('.partial-modal').length > 0) {
        $('.partial-modal').remove();
        $('.modal-backdrop').remove();
    }
    

    var params = '';
    if ($theTriggerer) {
        $theTriggerer.css('pointer-events', 'none');
    }


    if (typeof(data) !== 'undefined' && data ) {
        for (var key in data) {
            if (data[key] !== '') {
               params += 'data-'+key+'="'+data[key]+'" ';
            }
       }
    }
    var partialModal = '<div class="partial partial-modal" id="partialModal"'+params+' style="display:none"></div>';
    $('body').append(partialModal);

    container = $("#partialModal");
    if (container.length == 0) {
        return false;
    }

    var unique_partial_id = Math.floor(Math.random() * 1000000),
        d = container.data(),
        data = {};

    for (var i in d) {
        if (i != 'partial') {
            data[i] = d[i];
        }
    }

    if (data) {
        data.current_url = window.location.pathname;
    }
    var ext_domain = '';
    if (container.data('ext_domain')) {
        ext_domain = container.data('ext_domain');
    }

    $.ajax({
        url: ext_domain + '/partial/' + d.partial,
        data: data,
        method: 'GET',
        success: function (data) {

            var newContent = $(data.markup);
            var t = container.replaceWith(newContent);

            if (newContent.text().length == 0) {
                newContent.remove();
            } else {
                newContent.modal('show').on('hidden.bs.modal', function () {
                    newContent.remove();
                    if ($theTriggerer) {
                        $theTriggerer.css('pointer-events', 'auto');
                    }
                });
            }

            $('body').removeClass('partials-loading')
            $('.loader.partial-loader').remove();

            initForm(newContent);

            GlobalApplication.execute_callbacks();

            if (typeof (cb) !== 'undefined') {
                try {cb(newContent);} catch (error) { }
                if ($theTriggerer) {
                    $theTriggerer.css('pointer-events', 'auto');
                }
            }

            if (typeof (cb2) !== 'undefined') {
                newContent.data('callback', cb2);
            }
           
        },
        error: function (response) {
            $('body').removeClass('partials-loading');
            $('.partial-loader').remove();
            
            if ($theTriggerer) {
                $theTriggerer.css('pointer-events', 'auto');
            }
        }
    });
}
